import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Row, Col } from 'antd'
import axios from 'axios'
import AdminHeader from '../../CommonComponents/AdminHeader'
import AdminFooter from '../../CommonComponents/AdminFooter'
import {
  getChildrenList,
  GetHomeVisitById,
  IMG_URL,
} from '../../APIComponents/AdminApi'

const { Option } = Select

const HomeVisitReport = () => {
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [reportData, setReportData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    try {
      const res = await axios.get(getChildrenList)
      setStudents(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchReport = async () => {
    if (!selectedStudent) return

    setLoading(true)
    try {
      const res = await axios.get(`${GetHomeVisitById}/${selectedStudent}`)
      setReportData(res.data.data || res.data)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const getTypeOfHouse = (val) => {
    switch (val) {
      case 1:
        return 'पक्के घर'
      case 2:
        return 'कच्चे घर'
      default:
        return '-'
    }
  }

  const getOwnership = (val) => {
    switch (val) {
      case 1:
        return 'स्वतःचे'
      case 2:
        return 'भाड्याचे'
      default:
        return '-'
    }
  }

  const yesNo = (val) => {
    return val === 1 ? 'होय' : 'नाही'
  }

  const isPDF = (file) => {
    return file?.toLowerCase().endsWith('.pdf')
  }

  return (
    <>
      <AdminHeader />

      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">
              Home Visit Report
            </h3>
          </div>

          <Row gutter={16} className="mb-3 shadow rounded py-3 m-0 bg-white">
            <Col md={8}>
              <Select
                className="w-100"
                placeholder="Select Student"
                onChange={(val) => setSelectedStudent(val)}
              >
                {students.map((child) => (
                  <Option key={child.id} value={child.id}>
                    {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                    {child.reg_no})
                  </Option>
                ))}
              </Select>
            </Col>

            <Col md={8}>
              <Button type="primary" onClick={fetchReport}>
                Show Report
              </Button>

              <Button style={{ marginLeft: 10 }} onClick={() => window.print()}>
                Print
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin size="large" />
          ) : Array.isArray(reportData) && reportData.length > 0 ? (
            <div className="a4-page">
              {/* HEADER */}
              <div className="text-center pb-3">
                <h2>
                  <b>सेंट क्रिस्पिन्स होम</b>
                </h2>
                <h5>
                  <b>घर भेट अहवाल</b>
                </h5>
              </div>

              {reportData.map((item, i) => (
                <div key={i} className="section">
                  {/* STUDENT NAME */}
                  <div className="row p-0 m-0">
                    <div className="col-12">
                      <p>
                        <b>विद्यार्थ्याचे नाव:</b> {item.student?.fname}{' '}
                        {item.student?.mname} {item.student?.lname}
                      </p>
                    </div>
                  </div>

                  {/* DETAILS */}
                  <div className="row p-0 m-0">
                    <div className="col-12 col-md-6">
                      <p>
                        <b>भेट दिनांक:</b> {item.date_of_visit}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>भेट देणाऱ्याचे नाव:</b> {item.name_of_visitor}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>नाते:</b> {item.visitor_relation}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>घराचा प्रकार:</b>{' '}
                        {getTypeOfHouse(item.type_of_house)}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>मालकी हक्क:</b> {getOwnership(item.ownership_status)}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>खोल्यांची संख्या:</b> {item.number_of_rooms}
                      </p>
                    </div>
                    <div className="col-12 col-md-4">
                      <p>
                        <b>पाणी सुविधा:</b> {yesNo(item.water_facility)}
                      </p>
                    </div>
                    <div className="col-12 col-md-4">
                      <p>
                        <b>वीज:</b> {yesNo(item.electricity)}
                      </p>
                    </div>
                    <div className="col-12 col-md-4">
                      <p>
                        <b>स्वच्छता सुविधा:</b>{' '}
                        {yesNo(item.sanitation_facility)}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        <b>भेटीत भेटलेले सदस्य:</b>{' '}
                        {item.members_met_during_visit}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        <b>बालकाबद्दल निरीक्षण:</b> {item.observation_on_child}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        <b>घराची स्थिती:</b> {item.general_condition_of_home}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        <b>शिफारसी:</b> {item.recommendations}
                      </p>
                    </div>
                  </div>

                  {/* IMAGE */}
                  <div className="section">
                    <div className="row p-0 m-0">
                      <div className="col-12">
                        <p>
                          <b>घर भेट फोटो / दस्तऐवज:</b>
                        </p>

                        {item.home_visit_photo ? (
                          isPDF(item.home_visit_photo) ? (
                            <iframe
                              src={`${IMG_URL}${item.home_visit_photo}`}
                              title="PDF Viewer"
                              className="pdf-viewer"
                            />
                          ) : (
                            <img
                              src={`${IMG_URL}${item.home_visit_photo}`}
                              className="doc-img"
                              alt="home-visit"
                            />
                          )
                        ) : (
                          <p>उपलब्ध नाही</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ padding: 20 }}>No Data Found</p>
          )}
        </div>
      </div>

      <AdminFooter />

      {/* CSS */}
      <style>{`
        .a4-page {
          width: 210mm;
          min-height: 297mm;
          padding: 20px 60px;
          background: white;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .pdf-viewer {
            width: 100%;
            height: 600px;
            border: 1px solid black;
          }

        .section {
          margin-bottom: 20px;
        }

        .section p {
          color: black;
        }

        .text-center {
          text-align: center;
        }

        .doc-img {
          width: 100%;
          height: auto;
          max-height: 500px;
          object-fit: contain;
          margin-bottom: 15px;
          border: 1px solid black;
        }

        @media print {
          body * {
            visibility: hidden;
          }

          .a4-page, .a4-page * {
            visibility: visible;
          }

          .a4-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 210mm;
          }

          .doc-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .section {
            page-break-inside: avoid;
          }

          .row {
            display: flex !important;
            flex-wrap: wrap !important;
          }

          .col-md-6 {
            width: 50% !important;
            float: left !important;
          }

          .col-md-4 {
            width: 33.33% !important;
            float: left !important;
          }

          .col-md-8 {
            width: 66.66% !important;
            float: left !important;
          }

          .col-md-12 {
            width: 100% !important;
            float: left !important;
          }

          .row > div {
            padding: 2px !important;
          }
        }
      `}</style>
    </>
  )
}

export default HomeVisitReport
